import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
//import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 5e: Strategies',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Personal Reflection: How do you feel when using this component when trying to assist someone? `}
        />
        <strong>
          Personal Reflection: How do you feel when using this component when trying to assist someone?
        </strong>
      </Fragment>
    ),
    result: [],
    feedback: {
      correct: '',
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: '',
      optionText:
        'I have to be really focused and intentional when doing this.'
    },
    {
      prefix: 'B',
      result: '',
      optionText:
        'I am often able to do this but it’s a good reminder.'
    },
    {
      prefix: 'C',
      result: '',
      optionText:
        'I always do this.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={7}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="6. Instill a sense of hope" />
              <h2 className="txt-green no-bold no-margin">
                6. Instill a sense of hope
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className="no-bottom-padding">
        <div className="container">
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="We can instill a sense of hope. You can re-assure them that they are not alone, that help is available, and that you are willing to assist them. For example, you could say 'yThere are people out 
                there who face similar mental health challenges and are receiving help. I really care about your wellbeing and I’d like to help as well'. In the Refer section, we will learn how to connect them to available resources and services." />
              <p>
                We can instill a sense of hope.
                You can re-assure them that they are not alone, that help is available, and that you are willing
                to assist them. For example, you could say <span style={{ fontStyle: "italic" }}>“There are people out 
                there who face similar mental health challenges and are receiving help. I really care about your wellbeing 
                and I’d like to help as well.”</span>
              </p>
              <p>
                In the Refer section, we will learn how to connect them to available resources and services.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        categoary="survey"
        showLetter={false}
        nextRoute={url.ASSIST_I}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistH = connect.role(AssistPage);

export default AssistH;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistH/index.jsx